import request from "@/utils/request"

export default function agentGetOrderListByWhere(params, pageNum = 1, size = 10) {
    return request({
        url: `/fund/payLog/getPayLogByPage/${pageNum}/${size}`,
        params: params
    })
}
